<template>
  <transition name="fade">
    <div v-if="Object.keys(summary).length">
      <div class="section" id="cont">
        <!--  Header  -->
        <section id="views" class="hero title-card">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">
                Resumen del Resultado de CL7 - Clima Laboral
              </h1>
              <h2 class="subtitle" v-if="proceso.processComp">
                Comparado con {{ proceso.processComp.nombre }}
              </h2>
            </div>
            <div>
              <span>Fecha de diagnóstico</span>
              <h4 class="has-text-dark">{{ dateProcess(infoProcess.date) }}</h4>
              <button
                v-if="showCalcChangesUI"
                class="button is-small cl7-changes-btn"
                v-on:click="openCalcModal"
              >
                <span class="icon"
                  ><i class="material-icons">error_outline</i></span
                >
                <span>Cambios en el cálculo</span>
              </button>
            </div>
          </div>
        </section>

        <!--  Data  -->
        <div ref="stickySentinel" class="sticky-sentinel"></div>
        <!-- Sección de filtros activos (chips removibles), estilo FRP.
             Va fija arriba, encima de la leyenda. -->
        <div
          v-if="showSection && Object.keys(childFilters).length"
          class="clima-filter-banner"
        >
          <span class="clima-filter-banner-label">
            <i class="material-icons">filter_alt</i>
            <strong>Vista filtrada</strong>
          </span>
          <div class="clima-filter-banner-items">
            <template v-for="(subs, g) in childFilters">
              <span
                v-for="(sg, i) in subs"
                :key="g + '-' + sg + '-' + i"
                class="clima-filter-chip"
              >
                <span class="clima-filter-chip-group">{{ g }}</span>
                <span class="clima-filter-chip-sub">{{ sg }}</span>
                <button
                  class="clima-filter-chip-delete"
                  aria-label="Quitar filtro"
                  v-on:click="$refs.content.deselectOne({ group: g, name: sg })"
                >
                  ✕
                </button>
              </span>
            </template>
          </div>
          <button
            class="clima-filter-banner-clear"
            v-on:click="$refs.content.deselectFilter()"
          >
            <i class="material-icons">delete_sweep</i>
            <span class="is-hidden-mobile">Limpiar filtros</span>
          </button>
        </div>
        <div
          ref="subHeader"
          class="sub-header"
          :class="{
            'is-stuck': stuck,
            'has-filter-banner':
              showSection && Object.keys(childFilters).length,
          }"
        >
          <div class="sub-header__inner">
            <div class="sub-header__legend" :class="{ 'is-open': legendOpen }">
              <button
                type="button"
                class="legend-toggle"
                v-on:click="legendOpen = !legendOpen"
              >
                <i class="material-icons">
                  {{ legendOpen ? "expand_less" : "expand_more" }}
                </i>
                <span>{{
                  legendOpen ? "Ocultar leyenda" : "Ver leyenda"
                }}</span>
              </button>
              <table
                class="is-flex is-justify-start table-radius-6"
                style="width: 100%"
              >
                <tr
                  v-tooltip.bottom-start="{
                    content:
                      'Menos del 16% de las personas en alto o muy alto.<br><br>Esto duele. Muy pocas personas tienen percepciones muy positivas. Requiere escucha profunda e intervención prioritaria.',
                    classes: ['tooltip-custom'],
                    html: true,
                  }"
                >
                  <div class="p-2 bg-muyinconveniente"></div>
                  <td class="p-2">Actuemos ya</td>
                </tr>

                <tr
                  v-tooltip.bottom-start="{
                    content:
                      'Entre el 16% y el 29.9% de personas en alto o muy alto.<br><br>Las percepciones muy favorables las tienen pocas personas. Requiere conversación, acciones visibles y persistencia.',
                    classes: ['tooltip-custom'],
                    html: true,
                  }"
                >
                  <div class="p-2 bg-inconveniente"></div>
                  <td class="p-2">Necesita atención pronto</td>
                </tr>

                <tr
                  v-tooltip.bottom-start="{
                    content:
                      'Entre el 30% y el 49.9% de personas en alto o muy alto.<br><br>Aquí hay señales mixtas. Algunas personas lo viven bien, otras no tanto. Necesitamos entender mejor y actuar con coherencia.',
                    classes: ['tooltip-custom'],
                    html: true,
                  }"
                >
                  <div class="p-2 bg-regular"></div>
                  <td class="p-2">Cuidado</td>
                </tr>

                <tr
                  v-tooltip.bottom-start="{
                    content:
                      'Entre el 50% y el 69.9% de personas en alto o muy alto.<br><br>Una proporción importante de personas percibe favorablemente su entorno laboral, pero aún no es una experiencia suficientemente consistente en toda la organización.',
                    classes: ['tooltip-custom'],
                    html: true,
                  }"
                >
                  <div class="p-2 bg-medioregular"></div>
                  <td class="p-2">Estamos cerca</td>
                </tr>

                <tr
                  v-tooltip.bottom-start="{
                    content:
                      'Entre el 70% y el 83.9% de personas en alto o muy alto.<br><br>Hay buenas percepciones, pero también oportunidades sutiles de mejora. Es momento de afinar y reforzar.',
                    classes: ['tooltip-custom'],
                    html: true,
                  }"
                >
                  <div class="p-2 bg-positivo"></div>
                  <td class="p-2">Vamos bien</td>
                </tr>

                <tr
                  v-tooltip.bottom-start="{
                    content:
                      'Si el 84% o más de las personas está en los niveles de alto y muy alto.<br><br>¡Lo estamos haciendo muy bien! Esto refleja percepciones positivas para la mayoría. Hay que mantenernos y celebrarlo.',
                    classes: ['tooltip-custom'],
                    html: true,
                  }"
                >
                  <div class="p-2 bg-excelente"></div>
                  <td class="p-2">Sigamos así</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="sub-header__actions">
            <a
              v-if="tokenUser && tokenUser.admin & !showSection"
              href="javascript:void(0)"
              class="button is-small is-dark radius-6 sticky-hide"
              :disabled="this.validCtx"
              v-on:click="switchContext"
              style="gap: 5px"
            >
              <img
                src="@/assets/icons/ranking-linear.svg"
                alt="benchmark"
                class="btn-benchmark-icon"
              />
              <span
                >{{
                  generalContext.status ? "Ocultar" : "Mostrar"
                }}
                Benchmark</span
              >
            </a>
            <a
              v-if="!$route.params.id && showSection"
              href="javascript:void(0)"
              class="button is-small is-dark radius-6 sticky-hide"
              v-on:click="share()"
              v-tooltip="'Compartir Tablero'"
            >
              <i class="material-icons">share</i>
            </a>
            <a
              href="javascript:void(0)"
              class="button is-small is-dark radius-6 sticky-hide"
              v-on:click="dwData"
              v-tooltip="'Descargar Resultados'"
            >
              <i class="material-icons">cloud_download</i>
            </a>
          </div>
        </div>

        <!-- SubHeader - Cards Info  -->
        <section style="margin-top: 25px">
          <div class="columns is-multiline kpi-cards-row">
            <div
              class="column is-full-mobile is-one-third-tablet is-one-fifth-widescreen"
            >
              <KpiCard
                icon="chart-pie"
                title="Participación"
                :value="`${infoProcess.participation}%`"
                :subtitle="
                  `${infoProcess.totalParti} de ${infoProcess.totalColab} colaboradores`
                "
                value-color="#510087"
              />
            </div>

            <div
              class="column is-full-mobile is-one-third-tablet is-one-fifth-widescreen"
            >
              <KpiCard
                icon="clipboard-text-outline"
                title="Encuestados"
                :value="infoProcess.totalParti"
                :extra="
                  infoProcess.totalProcess
                    ? `(${infoProcess.totalProcess} en proceso)`
                    : ''
                "
                subtitle="Respondieron y participaron"
              />
            </div>

            <div
              class="column is-full-mobile is-one-third-tablet is-one-fifth-widescreen"
            >
              <kpi-card
                icon="check-circle-outline"
                title="Encuestas válidas"
                :value="infoProcess.totalValid"
                subtitle="Incluidas en resultados"
              />
            </div>

            <div
              class="column is-full-mobile is-one-third-tablet is-one-fifth-widescreen"
            >
              <KpiCard
                icon="minus-circle-outline"
                title="Eliminados"
                :value="infoProcess.totalEliminated"
                subtitle="Ceros e inconsistencias"
              />
            </div>

            <div
              class="column is-full-mobile is-one-third-tablet is-one-fifth-widescreen"
            >
              <KpiCard
                icon="account-cancel-outline"
                title="Sin consentimiento"
                :value="infoProcess.totalNoConsent"
                subtitle="Consentimiento no aceptado"
              />
            </div>
          </div>
        </section>

        <!--  Section Views  -->
        <div id="views">
          <transition name="fade">
            <!--   ResultadosGeneral - ResultadosDetallado   -->
            <component
              ref="content"
              :is="showSection ? 'ResultadosDetallado' : 'ResultadosGeneral'"
              :summaryTotal="this.summary"
              :infoProcessTotal="this.infoProcess"
              :generalContext="this.generalContext"
              :proceso="this.proceso"
              :processValuesCal="processValuesCal"
              :createdLineContext="createdLineContext"
              :validCtx="this.validCtx"
              @section="section"
              @goToGuie="goToGuie"
              @getPosition="getPosition"
              @filtersChanged="childFilters = $event || {}"
              :showSection="showSection"
              style="margin-top: 20px"
            ></component>
          </transition>
        </div>

        <!--  Button more details and show guia  -->
        <div class="is-flex">
          <div
            v-on:click="section"
            v-if="!showSection"
            class="button is-dark"
            style="margin-top: 25px"
          >
            <span style="margin-right: 5px">{{
              showSection ? "Ocultar detalles" : "Ver detalles"
            }}</span>
            <span class="icon"
              ><i class="material-icons is-size-1">{{
                showSection ? "arrow_drop_up" : "arrow_drop_down"
              }}</i></span
            >
          </div>
          <div
            v-on:click="goToGuie"
            v-if="!showSection"
            class="button is-dark"
            style="margin-top: 25px; margin-left: 10px"
          >
            <span style="margin-right: 5px">Ver guía</span>
            <span class="icon"
              ><i class="material-icons">local_library</i></span
            >
          </div>
        </div>
      </div>
      <ModalCambiosCalculo
        :show="showCalcModal"
        :comparison="calcComparison"
        @close="showCalcModal = false"
      />
    </div>
  </transition>
</template>

<script>
import { CLIMA_COLORS } from "./climaColors";
import apiServices from "@/services/yungol-services";
import ResultadosGeneral from "./ResultadosGeneral";
import ResultadosDetallado from "./ResultadosDetallado";
import ModalCambiosCalculo from "./ModalCambiosCalculo.vue";
import { mapState } from "vuex";
import * as XLSX from "xlsx-js-style";
import KpiCard from "./components/kpiCard.vue";

// Indicadores que cambiaron de cálculo (total general). Se comparan el valor
// anterior (summary.legacy, conteo por rango individual de cada encuesta) contra
// el nuevo (summary.total, normalizado por dimensión).
const CLIMA_AGG_GROUPS = [
  { key: "CClimad", label: "Clima total" },
  { key: "apoyod", label: "Apoyo" },
  { key: "calidadd", label: "Calidad" },
  { key: "innovaciond", label: "Innovación" },
  { key: "metasd", label: "Metas" },
];
const CLIMA_RANGES = ["Muy bajo", "Bajo", "Medio", "Alto", "Muy alto"];

// Aviso de cambios en el cálculo: solo para procesos creados antes de esta fecha.
const CALC_CHANGES_CUTOFF_DATE = new Date(2026, 5, 1);

export default {
  data() {
    return {
      summary: {},
      showSection: false,
      infoProcess: {},
      generalContext: {
        status: false,
        data: {},
        headers: {},
      },
      stuck: false,
      // Leyenda colapsable en móvil (en escritorio siempre visible).
      legendOpen: false,
      // Filtros activos reportados por ResultadosDetallado (grupo -> subgrupos).
      childFilters: {},
      // Modal informativo de cambios en el cálculo de resultados.
      showCalcModal: false,
      calcComparison: [],
    };
  },
  props: {
    proceso: {
      type: Object,
    },
  },
  computed: {
    ...mapState(["empresa", "tokenUser"]),
    validCtx() {
      return (
        this.isEmpty(this.generalContext.data) &&
        this.isEmpty(this.generalContext.headers)
      );
    },
    // Solo procesos creados antes de CALC_CHANGES_CUTOFF_DATE.
    showCalcChangesUI() {
      if (!this.proceso || !this.proceso.created) return false;
      return new Date(this.proceso.created) < CALC_CHANGES_CUTOFF_DATE;
    },
  },
  methods: {
    // Sticky legend: collapse its height once it sticks to the top.
    initStickyObserver() {
      this.$nextTick(() => {
        const sentinel = this.$refs.stickySentinel;
        if (!sentinel || this._stickyObserver) return;
        this._stickyObserver = new IntersectionObserver(
          ([entry]) => {
            this.stuck = !entry.isIntersecting;
          },
          { threshold: 0 },
        );
        this._stickyObserver.observe(sentinel);
      });
    },
    // Data
    async findSummary() {
      try {
        const result = await apiServices.post(`/traecalculoclima`, {
          filters: [],
          proceso: this.proceso._id,
        });
        if (result.data) {
          const historic = this.proceso.historic || [];
          if (historic.length) {
            const historicResults = await Promise.all(
              historic.map((p) =>
                apiServices.post(`/traecalculoclima`, {
                  filters: [],
                  proceso: p._id,
                }),
              ),
            );
            const historicSeriesAsc = historicResults
              .map((r, i) => ({
                procesoId: historic[i]._id,
                nombre: historic[i].nombre,
                fecha: historic[i].created,
                total: this.processValuesCal(r.data.calculos).total,
              }))
              .reverse();
            result.data.calculos.series = [
              ...historicSeriesAsc,
              {
                procesoId: this.proceso._id,
                nombre: this.proceso.nombre,
                fecha: result.data.infoProcess && result.data.infoProcess.date,
                total: this.processValuesCal(result.data.calculos).total,
              },
            ];
            const series = result.data.calculos.series;
            result.data.calculos.processComp =
              series.length > 1 ? series[series.length - 2] : null;
          }
          this.infoProcess = result.data.infoProcess;
          this.summary = this.processValuesCal(result.data.calculos);
          this.initStickyObserver();
          this.maybeShowCalcModal();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGeneralContext() {
      try {
        if (
          this.tokenUser &&
          !(this.tokenUser.admin || this.tokenUser.cliente)
        )
          return;
        const result = await apiServices.get("/cl7/generalContext");
        if (result.data) {
          this.generalContext.data = result.data.context;
          this.generalContext.headers = result.data.headers;
          this.generalContext.headers.position = this.getPosition(
            result.data.headers,
            "CClimad",
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    // General Context
    createdLineContext(group) {
      if (!group && !Object.keys(this.generalContext.data).length) return null;

      const position = this.summary.total[group].p;
      const context = Object.entries(this.generalContext.data[group]);
      const labels = context.map(([k, v]) => parseInt(k));
      const colors = labels.map((v) => this.getInfoRange(v));

      return {
        type: "line",
        data: {
          datasets: [
            {
              label: "Empresas",
              data: context.map(([k, v]) => {
                return { x: Number(k), y: Number(v) };
              }),
              fill: false,
              color: colors,
              backgroundColor: colors,
              borderColor: "rgb(75, 192, 192)",
              tension: 0.2,
              pointRadius: function(context) {
                const dataIndex = context.dataIndex;
                const dataset = context.dataset.data;

                // if (dataIndex === 0 || dataIndex === dataset.length - 1) {
                //   return 4;
                // }

                const value = dataset[dataIndex].y;
                return value === 0 ? 0 : 4;
              },
            },
          ],
        },
        options: {
          tooltips: {
            callbacks: {
              title: function(tooltipItem, data) {
                const value = tooltipItem[0].label;
                const nextStep = parseInt(value) + 5; // 5 es el stepSize de los ticks en xAxes
                return `${this.getInfoRange(
                  value,
                  "title",
                )} (${value}% al ${nextStep}%)`;
              }.bind(this),
            },
          },
          legend: { display: false, position: "right" },
          responsive: true,
          maintainAspectRatio: false,
          resizeDelay: 0,
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 2,
                  beginAtZero: true,
                  padding: 0,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                type: "linear",
                ticks: {
                  stepSize: 5,
                  min: Math.min(...labels),
                  max: Math.max(...labels),
                  autoSkip: false,
                  display: false,
                },
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          annotation: {
            annotations: [
              {
                id: "a-line-1",
                type: "line",
                mode: "vertical",
                scaleID: "x-axis-0",
                value: position.toFixed(2),
                borderColor: "rgba(0, 0, 0, 0.5)",
                borderWidth: 2,
                labelEnabled: true,
                imagenStatus: false,
                label: {
                  enabled: true,
                  content: ".",
                  position: "top",
                  fontColor: "#FFFFFF",
                  fontSize: 14,
                  fontStyle: "bold",
                  fontFamily: "Arial",
                  backgroundColor: "rgba(0, 0, 0, 0)",
                  xPadding: 10,
                  yPadding: 0,
                  yAdjust: 0,
                  cornerRadius: 5,
                },
              },
            ],
          },
        },
        plugins: [
          {
            beforeDraw: (chart) => {
              const ctx = chart.chart.ctx;

              const xScale = chart.scales["x-axis-0"];
              const yScale = chart.scales["y-axis-0"];

              xScale.ticks.forEach((tick, index) => {
                const tickX = xScale.getPixelForTick(index);
                ctx.fillStyle = this.getInfoRange(tick);
                const tickWidth =
                  index < xScale.ticks.length - 1
                    ? xScale.getPixelForTick(index + 1) - tickX
                    : xScale.right - tickX;

                ctx.fillRect(tickX, yScale.bottom, tickWidth, 20);
              });
            },
            afterDatasetsDraw: (chart) => {
              const ctx = chart.ctx;
              const sizeImg = 30;
              // Recorre las anotaciones y dibuja la imagen
              Object.entries(chart.annotation.elements).forEach(
                ([key, annotation]) => {
                  if (annotation.options.type !== "line") return;

                  const model = annotation._model;

                  if (!model || isNaN(model.x1) || isNaN(model.y1)) return;

                  if (annotation.options.imagenStatus) {
                    ctx.drawImage(
                      annotation.options.img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg,
                    );
                  }

                  // Dibuja una imagen junto al texto de la anotación
                  const img = new Image();
                  img.src = require("@/assets/icons/companyDefault.png");
                  img.onload = () => {
                    annotation.options.img = img;
                    ctx.drawImage(
                      img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg,
                    ); // Dibuja la imagen en el gráfico
                    annotation.options.imagenStatus = true;
                  };
                },
              );
            },
          },
        ],
      };
    },
    getInfoRange(value, type = "color") {
      const ranges = [
        {
          range: [0, 15], // Es 16 pero se acomoda a 15 para que se pnga en puntos de 5 en 5
          color: CLIMA_COLORS[6],
          title: "Actuemos ya",
        },
        {
          range: [15, 30],
          color: CLIMA_COLORS[5],
          title: "Necesita atención pronto",
        },
        { range: [30, 50], color: CLIMA_COLORS[4], title: "Cuidado" },
        {
          range: [50, 70],
          color: CLIMA_COLORS[3],
          title: "Estamos cerca",
        },
        { range: [70, 84], color: CLIMA_COLORS[2], title: "Vamos bien" },
        { range: [84, 100], color: CLIMA_COLORS[1], title: "Sigamos así" },
      ];
      const rangeObject = ranges.find(({ range }) => value < range[1]);
      return rangeObject ? rangeObject[type] : null;
    },
    switchContext() {
      if (this.validCtx) return;
      this.generalContext.status = !this.generalContext.status;
    },
    // Excel
    buildHeaders() {
      const ranges = [
        ["C", "D", "E", "F", "G"], // Clima Total
        ["H", "I", "J", "K", "L"], // Apoyo
        ["M", "N", "O", "P", "Q"], // Social
        ["R", "S", "T", "U", "V"], // Compromiso
        ["W", "X", "Y", "Z", "AA"], // Organizacional
        ["AB", "AC", "AD", "AE", "AF"], // Innovación
        ["AG", "AH", "AI", "AJ", "AK"], // Autonomía
        ["AL", "AM", "AN", "AO", "AP"], // Agilidad
        ["AQ", "AR", "AS", "AT", "AU"], // Mejora
        ["AV", "AW", "AX", "AY", "AZ"], // Calidad
        ["BA", "BB", "BC", "BD", "BE"], // Excelencia
        ["BF", "BG", "BH", "BI", "BJ"], // Consistencia y claridad
        ["BK", "BL", "BM", "BN", "BO"], // Seguridad
        ["BP", "BQ", "BR", "BS", "BT"], // Metas
        ["BU", "BV", "BW", "BX", "BY"], // Logro
        ["BZ", "CA", "CB", "CC", "CD"], // Servicio
        ["CE", "CF", "CG", "CH", "CI"], // Reputación
        ["CJ", "CK", "CL", "CM", "CN"], // Liderazgo
        ["CO", "CP", "CQ", "CR", "CS"], // Engagement
        ["CT", "CU", "CV", "CW", "CX"], // Recursos
        ["CY", "CZ", "DA", "DB", "DC"], // Compensación
      ];
      const rangesColumns = [];

      ranges.map((item) => {
        rangesColumns.push(
          { row: 2, from: item[0], to: item[0], value: "Muy bajo" },
          { row: 2, from: item[1], to: item[1], value: "Bajo" },
          { row: 2, from: item[2], to: item[2], value: "Medio" },
          { row: 2, from: item[3], to: item[3], value: "Alto" },
          { row: 2, from: item[4], to: item[4], value: "Muy alto" },
        );
      });

      const headers = [
        // Fila 1
        { row: 1, from: "C", to: "G", value: "Clima Total" },
        { row: 1, from: "H", to: "L", value: "Apoyo" },
        { row: 1, from: "M", to: "Q", value: "Social" },
        { row: 1, from: "R", to: "V", value: "Compromiso" },
        { row: 1, from: "W", to: "AA", value: "Organizacional" },
        { row: 1, from: "AB", to: "AF", value: "Innovación" },
        { row: 1, from: "AG", to: "AK", value: "Autonomía" },
        { row: 1, from: "AL", to: "AP", value: "Agilidad" },
        { row: 1, from: "AQ", to: "AU", value: "Mejora" },
        { row: 1, from: "AV", to: "AZ", value: "Calidad" },
        { row: 1, from: "BA", to: "BE", value: "Excelencia" },
        { row: 1, from: "BF", to: "BJ", value: "Consistencia y claridad" },
        { row: 1, from: "BK", to: "BO", value: "Seguridad" },
        { row: 1, from: "BP", to: "BT", value: "Metas" },
        { row: 1, from: "BU", to: "BY", value: "Logro" },
        { row: 1, from: "BZ", to: "CD", value: "Servicio" },
        { row: 1, from: "CE", to: "CI", value: "Reputación" },
        { row: 1, from: "CJ", to: "CN", value: "Liderazgo" },
        { row: 1, from: "CO", to: "CS", value: "Engagement" },
        { row: 1, from: "CT", to: "CX", value: "Recursos" },
        { row: 1, from: "CY", to: "DC", value: "Compensación" },

        // Fila 2
        { row: 2, from: "A", to: "A", value: "Grupo" },
        { row: 2, from: "B", to: "B", value: "N" },
        ...rangesColumns,
      ];

      const merges = [];
      const headerMatrix = [];

      const cellHeaderStyle = {
        font: { bold: true },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } },
        },
      };

      for (let i = 0; i < 2; i++) headerMatrix.push([]);

      headers.forEach(({ row, from, to, value }) => {
        const r = row - 1;
        const start = this.colLetterToIndex(from);
        const end = this.colLetterToIndex(to);

        headerMatrix[r][start] = {
          v: value,
          t: "s",
          s: cellHeaderStyle,
        };

        if (start !== end) {
          merges.push({ s: { r, c: start }, e: { r, c: end } });
        }
      });

      return { headerMatrix, merges };
    },
    async getDataExcel() {
      const data = this.summary;
      const resultGroups = await apiServices.post(`/traegruposclima`, {
        proceso: this.proceso._id,
      });
      const groups = resultGroups.data;

      const total = {
        ...data.total,
        n: this.infoProcess.totalValid,
      };

      let dataResult = await this.excelFormat([total, ...groups]);

      return dataResult;
    },
    share() {
      // Delegate to the active child (ResultadosDetallado.copyLink)
      if (this.$refs.content && this.$refs.content.copyLink) {
        this.$refs.content.copyLink();
      }
    },
    async getCommentsSheet() {
      const result = await apiServices.post(
        `/listcommentsclima/${this.proceso._id}`,
        { filter: {} },
      );
      const comments = Array.isArray(result.data) ? result.data : [];

      const rows = comments
        .map((item) => item.responses && item.responses.comentarios)
        .filter((texto) => texto)
        .map((texto) => [texto]);

      return [["Comentario"], ...rows];
    },
    async dwData() {
      try {
        const { headerMatrix, merges } = this.buildHeaders();
        const data = await this.getDataExcel();
        const finalSheet = [...headerMatrix, ...data];
        const ws = XLSX.utils.aoa_to_sheet(finalSheet);
        const range = XLSX.utils.decode_range(ws["!ref"]);

        for (let R = 2; R <= range.e.r; ++R) {
          for (let C = 0; C <= XLSX.utils.decode_col("DC"); ++C) {
            const cellAddress = { c: C, r: R };
            const cellRef = XLSX.utils.encode_cell(cellAddress);
            const cell = ws[cellRef];
            const styleCenterCell = {
              alignment: {
                horizontal: "center",
                vertical: "center",
                wrapText: true,
              },
            };
            if (
              !cell ||
              cell.v === undefined ||
              cell.v === null ||
              cell.v === ""
            )
              continue;

            if (
              C >= XLSX.utils.decode_col("A") &&
              C <= XLSX.utils.decode_col("A")
            ) {
              // Columnas A a a
              cell.t = "s";
              cell.s = styleCenterCell;
            } else if (
              C >= XLSX.utils.decode_col("B") &&
              C <= XLSX.utils.decode_col("B")
            ) {
              // Columnas B a B
              cell.t = "n";
              cell.s = styleCenterCell;
            } else if (
              C >= XLSX.utils.decode_col("C") &&
              C <= XLSX.utils.decode_col("DC")
            ) {
              // Columnas C a DC
              cell.t = "n";
              cell.z = "#,##0.0\\%";
              cell.s = styleCenterCell;
            }
          }
        }
        ws["!merges"] = merges;
        ws["!cols"] = this.widthCols(finalSheet.slice(1));

        const commentsData = await this.getCommentsSheet();
        const wsComentarios = XLSX.utils.aoa_to_sheet(commentsData);
        wsComentarios["!cols"] = this.widthCols(commentsData);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Resultados");
        XLSX.utils.book_append_sheet(wb, wsComentarios, "Comentarios");
        XLSX.writeFile(wb, `Resultados-${this.proceso.nombre}.xlsx`);
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    async excelFormat(datos) {
      const calculatePorcentage = (v, sum) => {
        if (!sum) return null;
        const result = (v * 100) / sum;
        return Number.isFinite(result) ? result : null;
      };
      const structure = [
        "CClimad",
        "apoyod",
        "apsd",
        "vincd",
        "apod",
        "innovaciond",
        "autd",
        "agid",
        "mejd",
        "calidadd",
        "excd",
        "cycd",
        "segd",
        "metasd",
        "logrd",
        "servd",
        "repd",
        "lidd",
        "engad",
        "recd",
        "compd",
      ];
      let data = [];
      try {
        data = datos.map((item) => {
          const row = [item.name ? item.name : "General", item.n | 0];

          structure.map((s) => {
            const sumData = item[s].n1;
            const ranges = [
              calculatePorcentage(item[s]["Muy bajo"], sumData),
              calculatePorcentage(item[s]["Bajo"], sumData),
              calculatePorcentage(item[s]["Medio"], sumData),
              calculatePorcentage(item[s]["Alto"], sumData),
              calculatePorcentage(item[s]["Muy alto"], sumData),
            ];

            row.push(...ranges);
          });
          return row;
        });
        return data;
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    colLetterToIndex(letter) {
      let col = 0;
      for (let i = 0; i < letter.length; i++) {
        col *= 26;
        col += letter.charCodeAt(i) - 64;
      }
      return col - 1;
    },
    widthCols(data) {
      let values = [];

      // Recorre todas las filas
      for (const currentRow of data) {
        currentRow.forEach((cell, columnIndex) => {
          const cellValueLength = String(cell || "").length + 2;

          if (
            !values[columnIndex] ||
            values[columnIndex].width < cellValueLength
          ) {
            values[columnIndex] = { width: cellValueLength };
          }
        });
      }

      // Validar los títulos (asumiendo que están en la primera fila)
      const headerRow = data[0] || [];
      headerRow.forEach((header, index) => {
        const headerLength = String(header || "").length + 2;
        if (values[index].width < headerLength) {
          values[index] = { width: headerLength };
        }
      });

      return values;
    },

    // Others
    section() {
      this.showSection ? (this.showSection = false) : (this.showSection = true);
      // Al cambiar de vista el hijo se vuelve a montar sin filtros; se limpia la
      // sección de filtros activos para que no quede información obsoleta.
      this.childFilters = {};
    },
    effectNums() {
      /* gsap.to(this, {duration: 1.5, parti: Number(90)}) */
    },
    autoScroll() {
      setTimeout(() => {
        let el = document.getElementById("views");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    },
    dateProcess(d) {
      let date = new Date(d);
      let options = { year: "numeric", month: "long", day: "numeric" };
      date = date.toLocaleDateString("es-CO", options);
      return date;
    },
    processValuesCal(summary) {
      const labelsinicial = Object.keys(summary.total);
      for (let index in labelsinicial) {
        const label = labelsinicial[index];
        summary.total[label].p =
          ((summary.total[label].Alto + summary.total[label]["Muy alto"]) /
            (summary.total[label].Alto +
              summary.total[label]["Muy alto"] +
              summary.total[label].Medio +
              summary.total[label].Bajo +
              summary.total[label]["Muy bajo"])) *
          100;
        summary.total[label].n1 =
          summary.total[label].Alto +
          summary.total[label]["Muy alto"] +
          summary.total[label].Medio +
          summary.total[label].Bajo +
          summary.total[label]["Muy bajo"];
      }
      return summary;
    },
    goToGuie() {
      this.$emit("selectSection", { d: "yGuide", name: "Resultados" });
    },
    getPosition(headers, group) {
      const value = this.summary.total[group].p;
      if (value === null) return "-";
      group = group.toLowerCase();
      const position = headers.ranking[`${group}_p`].filter((item) => {
        if (item.proceso_id_mongo === this.proceso._id) return false;
        return item[`${group}_p`] > value;
      }).length;
      return position + 1;
    },
    isEmpty(ele) {
      if (ele === undefined) return true;
      if (typeof ele === "object") return Object.keys(ele).length === 0;
      return ele.length === 0;
    },
    // Arma la comparación del total general (CClimad + 4 cuadrantes): % favorable
    // anterior (summary.legacy: conteo por rango individual de cada encuesta) vs
    // nuevo (summary.total: normalizado por dimensión). Devuelve [{ label, pOld, pNew }].
    buildCalcComparison() {
      const total = this.summary && this.summary.total;
      const legacy = this.summary && this.summary.legacy;
      if (!total) return [];
      const favorablePct = (acc) => {
        if (!acc) return null;
        const denom = CLIMA_RANGES.reduce((s, r) => s + (acc[r] || 0), 0);
        if (!denom) return null;
        return (((acc.Alto || 0) + (acc["Muy alto"] || 0)) / denom) * 100;
      };

      return CLIMA_AGG_GROUPS.map((group) => {
        const newP = total[group.key] && total[group.key].p;
        return {
          label: group.label,
          pOld: legacy ? favorablePct(legacy[group.key]) : null,
          pNew: Number.isFinite(newP) ? newP : favorablePct(total[group.key]),
        };
      });
    },
    // Muestra el modal de cambios una sola vez por proceso (persistido en localStorage).
    maybeShowCalcModal() {
      if (!this.showCalcChangesUI) return;
      this.calcComparison = this.buildCalcComparison();
      const key = `cl7CalcChanges_${this.proceso._id}`;
      if (!localStorage.getItem(key)) {
        this.showCalcModal = true;
        localStorage.setItem(key, "1");
      }
    },
    openCalcModal() {
      this.calcComparison = this.buildCalcComparison();
      this.showCalcModal = true;
    },
  },
  mounted() {
    this.autoScroll();
    this.initStickyObserver();
  },
  beforeDestroy() {
    if (this._stickyObserver) this._stickyObserver.disconnect();
  },
  async created() {
    // this.effectNums();
    await this.findSummary();
    await this.getGeneralContext();
  },
  components: {
    ResultadosGeneral,
    ResultadosDetallado,
    KpiCard,
    ModalCambiosCalculo,
  },
};
</script>

<style lang="scss" scoped>
.cl7-changes-btn {
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  border-radius: 10px !important;
  background-color: #ffb020;
  color: #4a3200;
  border-color: #ffb020;
  font-weight: 600;
  box-shadow: 0 1px 4px rgba(255, 176, 32, 0.25);
  transition: background-color 0.15s ease, box-shadow 0.15s ease;

  .icon {
    margin: 0 !important;
    width: 16px !important;
    height: 16px !important;
  }

  .icon i {
    color: #4a3200;
    font-size: 16px !important;
  }

  &:hover,
  &:focus {
    background-color: #f59e0b;
    border-color: #f59e0b;
    color: #4a3200;
    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.35);
  }
}

.table-radius-6 > tr:last-child {
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.table-radius-6 > tr:first-child {
  border-top-left-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
}

.table-radius-6 {
  flex-wrap: wrap;
  gap: 8px 22px;
  align-items: center;
}

.table-radius-6 > tr {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  line-height: 15px;
  font-size: 14px;
}

.table-radius-6 tr > td {
  width: auto;
  margin: 0;
  padding-left: 6px;
  white-space: nowrap;
}

.table-radius-6 tr > div {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.radius-6 {
  border-radius: 6px !important;
}

.section {
  padding: 1rem 1.5rem;
}

.title-card {
  border-radius: 10px !important;
  background-color: #f3f3f3 !important;
}

/* Mobile-first: bloque de fecha apilado y centrado bajo el título. */
.title-card .hero-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.title-card .hero-body .container {
  width: 100%;
}

/* Centra el botón "Cambios en el cálculo" cuando está apilado. */
.title-card .hero-body > div:last-child .cl7-changes-btn {
  margin-left: auto;
  margin-right: auto;
}

/* Invert the ranking SVG so it reads as white on the dark button. */
.btn-benchmark-icon {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

/* Desktop (≥1024px): dos columnas — título a la izquierda, fecha a la
   derecha. Se quita el max-width del .container para que el título ocupe
   su columna y el bloque de fecha no se envuelva debajo. */
@media (min-width: 1024px) {
  .title-card .hero-body {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  .title-card .hero-body .container {
    flex: 1 1 auto;
    min-width: 0;
    max-width: none;
    width: auto;
  }

  .title-card .hero-body > div:last-child {
    flex: 0 0 auto;
    text-align: left;
  }

  .title-card .hero-body > div:last-child .cl7-changes-btn {
    margin-left: 0;
    margin-right: 0;
  }
}

/* Desde ~1120px hacia abajo reducimos las tipografías del header
   (mismas medidas que se usaban en el tamaño más pequeño). */
@media (max-width: 1215px) {
  .title-card .title {
    font-size: 1.1rem !important;
    line-height: 1.4;
  }

  .title-card .subtitle {
    font-size: 0.9rem !important;
  }

  .title-card .hero-body > div:last-child span {
    font-size: 0.8rem;
  }

  .title-card .hero-body > div:last-child h4 {
    font-size: 0.95rem;
  }
}
</style>

<style lang="scss">
// Layout interno del sub-header
.sub-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-bottom: 10px;
  flex: 1 1 auto;
  min-width: 0;
}

.sub-header__legend {
  flex: 1 1 auto;
  min-width: 0;
}

// Botón para desplegar la leyenda: oculto en escritorio, visible en móvil.
.legend-toggle {
  display: none;
}

.sub-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

// KPI cards: misma altura en toda la fila. Cada columna es flex para que
// la tarjeta (height: 100%) se estire hasta la altura de la más alta.
.kpi-cards-row {
  align-items: stretch;
}

.kpi-cards-row > .column {
  display: flex;
}

.kpi-cards-row .kpi-card {
  width: 100%;
}

// En el rango intermedio (widescreen: 5 tarjetas por fila y espacio justo)
// ocultamos el icono para dar más ancho al título. En pantallas más grandes
// (fullhd ≥1408px) las tarjetas ya tienen espacio y el icono vuelve.
@media (min-width: 1216px) and (max-width: 1407px) {
  .kpi-cards-row .kpi-header .icon {
    display: none;
  }
}

// Tablet y mobile: los ítems de la leyenda bajan
@media (max-width: 1023px) {
  .sub-header__inner {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .sub-header__legend {
    flex: 1 1 100%;
  }

  // La tabla wrappea; los ítems se empaquetan según su contenido
  .table-radius-6 {
    gap: 8px 18px;
  }

  .sub-header__actions {
    flex: 1 1 100%;
    justify-content: flex-end;
  }

  // Al fijarse el sub-header (sticky), ocultamos los botones secundarios
  // (compartir, descargar, benchmark) para no ocupar espacio; en la posición
  // normal siguen visibles.
  .sub-header.is-stuck .sticky-hide {
    display: none !important;
  }
}

// Leyenda colapsable en móvil: por defecto sólo se ve el botón "Ver leyenda".
@media (max-width: 768px) {
  .legend-toggle {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 6px;
    background: transparent;
    border: none;
    color: #510087;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
  }

  .legend-toggle .material-icons {
    font-size: 20px;
  }

  // Tabla de leyenda oculta por defecto; se muestra al desplegar.
  .sub-header__legend .table-radius-6 {
    display: none !important;
  }

  .sub-header__legend.is-open .table-radius-6 {
    display: flex !important;
    margin-top: 6px;
  }
}

.sticky-sentinel {
  height: 1px;
  width: 100%;
}

.sub-header {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  background: #ffffff;
  margin-top: 20px;
  margin-left: 2px;
  margin-right: 2px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  transition: padding 0.18s ease, box-shadow 0.18s ease, margin-top 0.18s ease,
    top 0.18s ease;
}

/* Cuando hay banner de filtros fijo arriba, la leyenda se ancla debajo de él
   para que ambas secciones sticky coexistan (primero filtros, luego leyenda). */
.sub-header.has-filter-banner {
  top: 44px;
}

/* Sección de filtros activos (chips removibles), estilo FRP. Fija arriba,
   por encima de la leyenda. */
.clima-filter-banner {
  position: sticky;
  top: 0;
  z-index: 31;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 2px 0;
  padding: 6px 14px;
  background: #f3e8ff;
  border: 1px solid #d9c2f0;
  border-radius: 10px;
  color: #4a148c;
  box-shadow: 0 2px 6px rgba(10, 10, 10, 0.12);
}
.clima-filter-banner-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12.5px;
  white-space: nowrap;
  color: #522687;
}
.clima-filter-banner-label .material-icons {
  font-size: 16px;
}
.clima-filter-banner-items {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: thin;
  padding-bottom: 2px;
}
.clima-filter-banner-items::-webkit-scrollbar {
  height: 4px;
}
.clima-filter-chip {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 5px 2px 11px;
  background: #fff;
  border: 1px solid #d9c2f0;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1.5;
}
.clima-filter-chip-group {
  color: #8268a8;
  font-weight: 600;
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.clima-filter-chip-sub {
  color: #3d1466;
  font-weight: 700;
}
.clima-filter-chip-delete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #a78bc7;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}
.clima-filter-chip-delete:hover {
  background: #f4dada;
  color: #c0392b;
}
.clima-filter-banner-clear {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid #522687;
  color: #522687;
  border-radius: 4px;
  padding: 2px 10px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}
.clima-filter-banner-clear:hover {
  background: #522687;
  color: #fff;
}
.clima-filter-banner-clear .material-icons {
  font-size: 15px;
}

// En móvil sólo se muestra el icono; padding simétrico para que quede cuadrado.
@media (max-width: 768px) {
  .clima-filter-banner-clear {
    gap: 0;
    padding: 4px 6px;
  }
}

/* When the legend sticks to the top, collapse its height so it takes
   up less room while staying visible. */
.sub-header.is-stuck {
  margin-top: 0;
  padding-top: 6px;
  padding-bottom: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.sub-header.is-stuck .table-radius-6 > tr {
  font-size: 12px;
  line-height: 12px;
}

.sub-header.is-stuck .p-2 {
  padding-top: 0.05rem;
  padding-bottom: 0.05rem;
}

.bg-excelente {
  background-color: var(--clima-1) !important;
  color: white;
}

.bg-positivo {
  background-color: var(--clima-2) !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-medioregular {
  background-color: var(--clima-3) !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-regular {
  background-color: var(--clima-4) !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-inconveniente {
  background-color: var(--clima-5) !important;
  color: rgba(65, 64, 64, 0.91);
}

.bg-muyinconveniente {
  background-color: var(--clima-6) !important;
  color: rgba(65, 64, 64, 0.91);
}

.p-2 {
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.fecha table {
  justify-content: end;
}

.box-sub {
  height: 118px !important;
}

.sub {
  margin-bottom: 6px !important;
}

/* Backgrounds */

.rango1 {
  background-color: var(--clima-1) !important;
  color: white !important;
}

.rango2 {
  background-color: var(--clima-2) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango3 {
  background-color: var(--clima-3) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango4 {
  background-color: var(--clima-4) !important; // f7d774a
  color: rgba(65, 64, 64, 0.91);
}

.rango5 {
  background-color: var(--clima-5) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango6 {
  background-color: var(--clima-6) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.8);
}

.tooltip-custom .tooltip-inner {
  width: 350px;
  max-width: 350px;
  border-radius: 6px;
  white-space: pre-line;
  background-color: rgba(0, 0, 0, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/climan/Resultadosclima.vue